import gsap from 'gsap';
import { TweenMax, TimelineLite, Power2, Elastic, Power1 } from "gsap";
import '../lib/SplitText';
import lottie from 'lottie-web';

class GeneralAnimations {
  static init(pageScroller, responsive) {
    this.titlesAnimation();
    this.playLottieOnScroll(pageScroller, '.lottie-wrapper');
    this.initLink(pageScroller);
    this.initMenuLink()
    if (responsive.mobile == false) {
      this.contentSlideInRight();
      this.contentSlideInLeft();
      this.contentSlideInBottom();
      this.Parallax();
      this.introAnimation();
    }
  }

  static introAnimation() {
    gsap.registerPlugin(Power1);
    const blurProperty = gsap.utils.checkPrefix("filter"),
    blurExp = /blur\((.+)?px\)/,
    getBlurMatch = target => (gsap.getProperty(target, blurProperty) || "").match(blurExp) || [];

    gsap.registerPlugin({
      name: "blur",
      get(target) {
        return +(getBlurMatch(target)[1]) || 0;
      },
      init(target, endValue) {
        let data = this,
            filter = gsap.getProperty(target, blurProperty),
            endBlur = "blur(" + endValue + "px)",
            match = getBlurMatch(target)[0],
            index;
        if (filter === "none") {
          filter = "";
        }
        if (match) {
          index = filter.indexOf(match);
          endValue = filter.substr(0, index) + endBlur + filter.substr(index + match.length);
        } else {
          endValue = filter + endBlur;
          filter += filter ? " blur(0px)" : "blur(0px)";
        }
        data.target = target;
        data.interp = gsap.utils.interpolate(filter, endValue);
      },
      render(progress, data) {
        data.target.style[blurProperty] = data.interp(progress);
      }
    });

    let $header = document.querySelector('header');
    let $imgHeader = document.querySelector('.intro .img-desktop')
    let $glassIcon = document.querySelector('h1 i')
    let titleSplit = new SplitText(document.querySelector('h1'), {type: 'words,chars'});
    let $subtitle = document.querySelector('.content .subtitle')
    let $title =  document.querySelector('h1');
    gsap.set(titleSplit.chars, {opacity: 0,  blur: 10})
    gsap.set($header, {yPercent:-100})
    gsap.set($imgHeader, {width:0})
    gsap.set($glassIcon, {blur: 5})
    gsap.set($subtitle, {opacity: 0, yPercent: -100})
    gsap.set($title, {xPercent: -5})

    let tl = gsap.timeline({repeat: 0});
    tl.to($glassIcon, {blur: 0, duration: 2}, 1);
    tl.to(titleSplit.chars, { blur: 0, opacity: 1, stagger: {each: 0.015}, duration: 1}, 2);
    tl.to($title, {xPercent: 0, duration: 1,
      onComplete: function() {
        $title.classList.add('active')
      }
    }, 2)
    tl.to($imgHeader, {width:"50%", duration: 1}, 4);
    tl.to($subtitle, {opacity: 1, yPercent: 0, duration: .5, ease: Power1.easeOut}, 5);
    tl.to($header, {yPercent:0, duration: .5,
      onComplete: function() {
        setTimeout(() => {
          $header.classList.add('loaded')
        }, 500)
    }}, 5);

  }
  static titlesAnimation() {
    let titles = document.querySelectorAll('.animated-title');
    if (titles.length == 0)
      return;

    titles.forEach((el) => {
      let titleSplit = new SplitText(el, {type: 'words,chars'});
      gsap.from(titleSplit.chars, {
        y: 30,
        opacity: 0,
        stagger: {
          each: 0.015,
        },
        scrollTrigger: {
          trigger: el,
          start: 'top 80%'
        },
      });
    });
  }

  static contentSlideInRight()  {
    let contents = document.querySelectorAll('.animated-sir');
    if (contents.length == 0)
      return;

    contents.forEach((el) => {
      gsap.from(el, {
        x: 25,
        opacity: 0,
        scrollTrigger: {
          trigger: el,
          start: 'top 80%'
        }
      });
    });
  }

  static contentSlideInLeft()  {
    let contents = document.querySelectorAll('.animated-sil');
    if (contents.length == 0)
      return;

    contents.forEach((el) => {
      gsap.from(el, {
        x: -25,
        opacity: 0,
        scrollTrigger: {
          trigger: el,
          start: 'top 80%'
        }
      });
    });
  }

  static contentSlideInBottom()  {
    let contents = document.querySelectorAll('.animated-sib');
    if (contents.length == 0)
      return;

    contents.forEach((el) => {
      gsap.from(el, {
        y: 25,
        opacity: 0,
        scrollTrigger: {
          trigger: el,
          start: 'top 80%'
        }
      });
    });
  }

  static Parallax() {
    let elements = document.querySelectorAll('.animated-parallax');
    if (elements.length == 0)
      return;

    elements.forEach((el) => {
      let range = el.dataset.range;
      let direction = el.dataset.direction;
      let setVal, toVal;

      if (direction == 'normal') {
        setVal = range;
        toVal = -range;
      } else if (direction == 'invert') {
        setVal = -range;
        toVal = range;
      }

      gsap.set(el, {
        yPercent: setVal,
      });
      gsap.to(el, {
        scrollTrigger: {
          trigger: el,
          scrub: 1,
          start: 'top bottom',
          end: 'bottom top',
        },
        yPercent: toVal,
      });
    });
  }

  static playLottieOnScroll(pageScroller, el) {
    let lottieWrapper = document.querySelector(el);
    if (lottieWrapper == null)
      return;

    let json = lottieWrapper.dataset.json;
    let posY = lottieWrapper.getBoundingClientRect().y - (window.innerHeight / 1.25);
    let lottieAnimation = lottie.loadAnimation({
      container: lottieWrapper,
      renderer: 'svg',
      autoplay: false,
      loop: true,
      path: json
    });
    pageScroller.pageScroller.addListener((status) => {
      if (status.offset.y > posY)
        lottieAnimation.play();
    });
  }

  static initLink(pageScroller) {
    let rdvLinks = document.querySelectorAll('a[href="#rdv"]');
    if (rdvLinks.length > 0) {
      let rdvWrapper = document.getElementById('rdv');
      rdvLinks.forEach(el => {
        el.addEventListener('click', (event) => {
          event.preventDefault();
          pageScroller.customScrollTo(rdvWrapper);
        });
      });
    }

    let homeLinks = document.querySelectorAll('a[href="#home"]');
    if (homeLinks.length > 0) {
      let homeWrapper = document.getElementById('home');
      homeLinks.forEach(el => {
        el.addEventListener('click', (event) => {
          event.preventDefault();
          pageScroller.customScrollTo(homeWrapper);
        });
      });
    }

    let offreLinks = document.querySelectorAll('a[href="#offre"]');
    if (offreLinks.length > 0) {
      let offreWrapper = document.getElementById('offre');
      offreLinks.forEach(el => {
        el.addEventListener('click', (event) => {
          event.preventDefault();
          pageScroller.customScrollTo(offreWrapper);
        });
      });
    }
    let offre2Links = document.querySelectorAll('.intro .subtitle i, .icon-fleche-mobile');
    if (offreLinks.length > 0) {
      let offreWrapper = document.getElementById('offre');
      offre2Links.forEach(el => {
        el.addEventListener('click', (event) => {
          event.preventDefault();
          pageScroller.customScrollTo(offreWrapper);
        });
      });
    }
    let shopLinks = document.querySelectorAll('a[href="#shop"]');
    if (shopLinks.length > 0) {
      let shopWrapper = document.getElementById('shop');
      shopLinks.forEach(el => {
        el.addEventListener('click', (event) => {
          event.preventDefault();
          pageScroller.customScrollTo(shopWrapper);
        });
      });
    }
    let examenLinks = document.querySelectorAll('a[href="#examen"]');
    if (examenLinks.length > 0) {
      let examenWrapper = document.getElementById('examen');
      examenLinks.forEach(el => {
        el.addEventListener('click', (event) => {
          event.preventDefault();
          pageScroller.customScrollTo(examenWrapper);
        });
      });
    }
    let philoLinks = document.querySelectorAll('a[href="#philo"]');
    if (philoLinks.length > 0) {
      let philoWrapper = document.getElementById('philo');
      philoLinks.forEach(el => {
        el.addEventListener('click', (event) => {
          event.preventDefault();
          pageScroller.customScrollTo(philoWrapper);
        });
      });
    }
  }

  static initMenuLink() {
    let menuLinks = document.querySelectorAll('.nav-item .nav-link');

    menuLinks.forEach((el) => {
      el.addEventListener('click', (e) => {
        menuLinks.forEach((item) => {
          item.classList.remove('active');
        })
        el.classList.add('active');
      })
    })
  }
}

export default GeneralAnimations;
